<template>
  <section class="not-found" aria-labelledby="not-found-title">
    <p class="status-code">404</p>
    <h1 id="not-found-title">这个页面不存在</h1>
    <p>链接可能已经失效，或者页面被移动了。</p>
    <router-link to="/" class="home-link">返回首页</router-link>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.not-found {
  width: min(calc(100% - 2rem), 640px);
  margin: 0 auto;
  padding: clamp(3rem, 10vw, 7rem) 1rem;
  text-align: center;
}

.status-code {
  margin: 0 0 0.5rem;
  color: #6b5f4c;
  font-size: clamp(3rem, 12vw, 5rem);
  font-weight: 800;
  line-height: 1;
}

.not-found h1 {
  margin: 0 0 1rem;
  font-size: clamp(1.75rem, 6vw, 2.5rem);
}

.not-found > p:not(.status-code) {
  margin-bottom: 2rem;
  color: var(--text-secondary);
  line-height: 1.7;
}

.home-link {
  display: inline-flex;
  min-height: 44px;
  padding: 0.7rem 1.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #6b5f4c;
  color: #ffffff;
  text-decoration: none;
}

.home-link:hover,
.home-link:focus-visible {
  background: #594f40;
  outline: 3px solid rgba(67, 97, 238, 0.2);
  outline-offset: 2px;
}
</style>
